import script from "./TrialBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrialBanner.vue?vue&type=script&lang=ts&setup=true"

import "./TrialBanner.vue?vue&type=style&index=0&id=fa009b36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa009b36"]])

export default __exports__